import { getParameters } from '../../../helpers/helpers';

import { PIN_POOL_FORM, VEHICLE_POOL_FORM } from './form-cardgroup-types';
import { createNewCardGroup } from './newCardGroup/create-new-cardgroup';
import { getIndividualCardGroup } from './existingCardGroup/get-cardgroup-info';
import { updateCardGroup } from './existingCardGroup/update-cardgroup';
import { cardGroupPinPool } from './pinPool/get-pin-pool';
import { updatePinPool } from './pinPool/update-pin-pool';
import CardGroupVehiclePin from './vehiclePin/get-vehicle-pins';
import UpdateVehiclePins from './vehiclePin/update-vehicle-pins';

/**
 * Handles routing for the Card Group form based on the groupAction parameter
 * 
 * @returns void
 */
export const formCardGroups = () => {
  const formAction = getParameters('groupAction');

  switch(formAction) {
    case 'add':
      createNewCardGroup();
      break;
    case 'edit':
    case 'view':
      getIndividualCardGroup();
      updateCardGroup();
      break;
  } 

  if ( PIN_POOL_FORM.ppForm ) {
    cardGroupPinPool();
    updatePinPool();
  }

  if ( VEHICLE_POOL_FORM.vpForm ) {
    CardGroupVehiclePin();
    UpdateVehiclePins();
  }
}